import SectionHeading from "./section-heading";
import React from "react";
import PricingCards from "../../components/shared/pricing-cards";
import {useTranslation} from "gatsby-plugin-react-i18next";

const PricingPlan = () => {
  const {t} = useTranslation();

  return (
    <section className="flex flex-col w-full max-w-screen-2xl mx-auto px-5 py-5 gap-5 h-full">
      <SectionHeading
        className="mb-10"
        eyebrow={t("Pricing")}
        title={t("Pick a plan,|change it whenever you want.")}
        lead={t("Every plan includes the whole product. What differs is how much you use it: the number of agents, the monthly credit budget and the size of the knowledge base.")}
      />
      <PricingCards/>
    </section>
  );
};

export default PricingPlan;
